import React, { useEffect, useState, useRef } from 'react';
import { useLoginFormStyle } from '../css/useLoginFormStyle';
import MyEirLoginHeader from './MyEirLoginHeader';
import MyEirLoginFooter from './MyEirLoginFooter';
import { useHistory } from 'react-router-dom';
import { CircularProgress, Typography } from '@material-ui/core';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { useApolloClient } from '@apollo/client';
import MyEirEmailConfirmationModal from '../../sharedcomponents/MyEirPostpayRegistration/MyEirEmailConfirmationModal';
import TerminatedTile from '../reusable-components/TerminatedTile';
import MyEirErrorHandle from '../eir-porting/MyEirErrorHandle';
import useRecaptchaV3 from '../../hooks/useRecaptchaV3';
import {
    handleSubmitLoginOperation,
    isUpdateAvailable,
    submitForgotResetPassword,
} from './loginOperation.util';
import ReCAPTCHA from 'react-google-recaptcha';
import { getDataFromEirAppDB } from '../redesign-5.2/biometrics/biometrics.util';
import EirButton from '../../theme/EirButton';
import OptInOptOutPopup from './OptInOptOutPopup';
import { getLatestAppVersionApi } from './loginOperation.api';
import { getTokenFromCookies } from '../redesign-5.2/redesign.api';
import LatestAppInfoPopup from './LatestAppInfoPopup';

const MyEirLoginOperation = props => {
    const { executeRecaptcha } = useRecaptchaV3('login');
    const { executeRecaptcha: executeRecaptchaReset } = useRecaptchaV3('resetPassword');
    const [userName, setUserName] = useState('');
    const [userPassword, setUserPassword] = useState('');
    const [passwordVisibility, setPasswordVisibility] = useState(false);
    const [registerToggle, setRegisterToggle] = useState(false);
    const [enableSubmit, setEnableSubmit] = useState(false);
    const [enableLogin, setEnableLogin] = useState(false);
    const validUserName = /^([a-zA-Z0-9_\-\.+]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
    const validPassword = /^.{6,}$/;
    const styleClass = useLoginFormStyle();
    const graphql = useApolloClient();
    const history = useHistory();
    const recaptchaRef = useRef(null);
    const [invalidText, setInvalidText] = useState('');
    const [captchaV2, setCaptchaV2] = useState('');
    const [captchaV2Error, setCaptchaV2Error] = useState(false);
    const [userCredential, setUserCredential] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [optPopup, setOptPopup] = useState(false);
    const [isPrepay, setIsPrepay] = useState(false);

    //Version checker for iOS devices

    const [showUpdatePopup, setShowUpdatePopup] = useState(false);
    const token = getTokenFromCookies();

    // error state variables
    const [waitingApiResponse, setWaitingApiResponse] = useState(props.waitingApiRes);
    const [openError, setOpenError] = useState(false);
    const [invalidError, setInvalidError] = useState(false);
    const [isOpen2, setIsopen2] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const [passChangedErr, setPassChangedErr] = useState(false);

    const toggleRegister = () => {
        setRegisterToggle(!registerToggle);
    };

    function handleUserVal(setname) {
        setUserName(setname);
    }
    async function handleSubmitLogin(enteredName, userPassword) {
        const recaptchaV3Token = await executeRecaptcha();
        const submitAction = await handleSubmitLoginOperation({
            graphql,
            enteredName,
            userPassword,
            recaptchaV3Token,
            setWaitingApiResponse,
            handleUserVal,
            setInvalidError,
            invalidError,
            toggleRegister,
            setOpenError,
            openError,
            setLoginScreen: props.setLoginScreen,
            setInvalidText,
            recaptchaRef,
            captchaV2,
            setCaptchaV2Error,
            captchaV2Error,
            userCredential,
            setOtpUuid: props.setOtpUuid,
            setLoginOperationValue: props.setLoginOperationValue,
            setIsLoading,
            setOptPopup,
            optPopup,
            setIsPrepay,
        });
    }

    function handleUserPassword(event) {
        setUserPassword(event.target.value);
    }

    function handlePasswordVisibility(event) {
        setPasswordVisibility(!passwordVisibility);
    }

    function validateUserName(name) {
        if (validUserName.test(name)) {
            setEnableSubmit(true);
        } else {
            setEnableSubmit(false);
        }
    }

    function handleUserName(event) {
        const name = event.target.value;
        setUserName(name);
        props.setUsername(name);
        setInvalidError(false);
        validateUserName(name);
    }
    function handleSubmitUsername() {
        setPassChangedErr(false);
        handleSubmitLogin(userName, userPassword);
    }
    function handleRegister() {
        history.push('/register');
    }

    function handleForgotUsername() {
        history.push('/forgot-email');
    }

    function handlePasswordVisibility(event) {
        setPasswordVisibility(!passwordVisibility);
    }
    function handleUserPassword(event) {
        const password = event.target.value;
        setUserPassword(password);
        setInvalidError(false);
        if (validPassword.test(password)) {
            setEnableLogin(true);
        } else {
            setEnableLogin(false);
        }
    }

    const toggle2 = () => {
        if (userName == '') {
            setEnableSubmit(false);
        } else {
            setIsopen2(!isOpen2);
        }
    };
    const toggleError = () => {
        setOpenError(!openError);
    };
    const togglePopup = () => {
        setShowUpdatePopup(!showUpdatePopup);
    };
    const onSubmit = async data => {
        // console.log('forgotten:', data);
        setIsClicked(true);
        sessionStorage.setItem('user', userName);
        const recaptchaV3Token = await executeRecaptchaReset();
        const submitReset = await submitForgotResetPassword({
            setWaitingApiResponse,
            graphql,
            userName,
            toggle2,
            toggleError,
            recaptchaV3Token,
        });
    };

    const handleKeyDown = e => {
        if (e.key === 'Enter') {
            handleSubmitLogin(userName, userPassword);
        }
    };

    function handleOnChange(value) {
        if (value == null) {
            setEnableLogin(false);
            // setEnableSubmit(false);
            setCaptchaV2Error(!captchaV2Error);
        } else {
            setCaptchaV2Error(!captchaV2Error);
            setCaptchaV2(value);
            setTimeout(() => {
                setEnableLogin(true);
                setEnableSubmit(true);
                setInvalidError(false);
            }, 1000);
        }
    }

    useEffect(() => {
        if (userName) {
            setUserName(userName);
            validateUserName(userName);
        }
    }, []);
    useEffect(() => {
        const fetchUpdate = async () => {
            try {
                const userAgent = window.navigator.userAgent.toLowerCase();
                const isIOSDevice = /iphone|ipad|ipod/.test(userAgent);
                const isInStandaloneMode = () =>
                    'standalone' in window.navigator && window.navigator.standalone;

                if (isIOSDevice && isInStandaloneMode()) {
                    const { version = '', build = '' } = window?.iOSAppInfo || {};
                    const currentVersion = build ? `${version}.${build}` : '0.0.0'; // Incase the current version is not detectable then use default value to get isUpdateRequired as true

                    const data = await getLatestAppVersionApi({ graphql });
                    const { latestVersion, recentVersions } = data?.latestAppVersion;

                    const isUpdateRequired = isUpdateAvailable({
                        currentVersion,
                        latestVersion,
                        recentVersions,
                    });
                    if (isUpdateRequired) {
                        setShowUpdatePopup(isUpdateRequired);
                    }
                }
            } catch (error) {
                console.error('error checking versions:', error);
                setShowUpdatePopup(false);
            }
        };

        const fetchDataFromEirAppDB = async () => {
            const value = await getDataFromEirAppDB('user_credential');
            setUserCredential(value);
        };
        const runSequence = async () => {
            await fetchUpdate();
            await fetchDataFromEirAppDB();
        };
        runSequence();
    }, []);

    useEffect(() => {
        setUserPassword('');
        const name = userCredential?.user;
        if (name) {
            setPassChangedErr(true);
            setUserName(name);

            props.setUsername(name);
            setInvalidError(false);
            validateUserName(name);
        }
    }, [props.flag, userCredential]);

    return (
        <div className={styleClass.loginContainer}>
            <form
                onSubmit={e => {
                    e.preventDefault();
                }}
                className={styleClass.cardContainer}
            >
                <MyEirLoginHeader headerText='Log in' flag='login' />
                <div className={styleClass.bodyContainer}>
                    <div className='text-field'>
                        <input
                            aria-label='Email address'
                            className={
                                'input-text' +
                                (isClicked && userName == ''
                                    ? ' text-entered-invalid'
                                    : !userName
                                    ? ' text-empty'
                                    : enableSubmit
                                    ? ' text-entered'
                                    : ' text-entered-invalid')
                            }
                            type='email'
                            id='email'
                            placeholder='Enter email'
                            value={userName}
                            onKeyDown={handleKeyDown}
                            autoComplete='username'
                            onChange={handleUserName}
                            disabled={waitingApiResponse}
                        />

                        {isClicked && userName == '' ? (
                            <Typography
                                variant='inputLabel'
                                className='invalid-email-format'
                                style={{ textAlign: 'left', fontSize: '14px', lineHeight: '20px' }}
                            >
                                Enter your email address and we'll send you a reset password link
                                email.
                            </Typography>
                        ) : (
                            !enableSubmit &&
                            userName != '' &&
                            !captchaV2Error && (
                                <Typography variant='inputLabel' className='invalid-email-format'>
                                    Please enter a valid email ID
                                </Typography>
                            )
                        )}

                        <Typography
                            tabindex='0'
                            role='link'
                            aria-label='Recover your email address'
                            variant='body2'
                            className='forgotten-input-text'
                            onClick={handleForgotUsername}
                            style={{ marginBottom: '24px' }}
                        >
                            Forgotten your email?
                        </Typography>
                        {!userName ? (
                            <></>
                        ) : (
                            <Typography
                                variant='inputLabel'
                                className={
                                    'text-field-name' +
                                    (enableSubmit ? '' : ' text-field-name-invalid')
                                }
                            >
                                Email
                            </Typography>
                        )}
                    </div>

                    {/*password field starts--*/}
                    <div className='text-field'>
                        <input
                            aria-label='Password'
                            className={
                                'input-text visibility-icon-padding' +
                                (!userPassword ? ' text-empty' : 'text-entered')
                            }
                            type={passwordVisibility ? 'text' : 'password'}
                            placeholder='Enter password'
                            value={userPassword}
                            onKeyDown={handleKeyDown}
                            autoComplete='current-password'
                            onChange={handleUserPassword}
                            disabled={waitingApiResponse}
                        />
                        {passwordVisibility ? (
                            <VisibilityOffIcon
                                tabindex='0'
                                aria-label='Hide Password'
                                className='visibility-off'
                                onClick={handlePasswordVisibility}
                            />
                        ) : (
                            <VisibilityIcon
                                tabindex='0'
                                aria-label='Show Password'
                                className='visibility-on'
                                onClick={handlePasswordVisibility}
                            />
                        )}

                        <div className='error-and-reset'>
                            <Typography
                                tabindex='0'
                                role='link'
                                aria-label='Recover your password'
                                variant='body2'
                                className='forgotten-input-text'
                                onClick={onSubmit}
                            >
                                Forgotten your password?
                            </Typography>
                        </div>

                        {!userPassword ? (
                            <></>
                        ) : (
                            <Typography variant='inputLabel' className={'text-field-name'}>
                                Password
                            </Typography>
                        )}
                    </div>
                    {/* password field end-- */}

                    {/**Recaptcha v2 incase v3 failed */}
                    {invalidText === 'Invalid reCAPTCHA!' && (
                        <div className={styleClass.reCaptchaError}>
                            <div className={styleClass.reCaptcha}>
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    className={'reCaptchaRobot'}
                                    sitekey='6LfZsRYTAAAAAJMBqawqK3sy7NmHDC8M9rKdkX36'
                                    render='explicit'
                                    onChange={handleOnChange}
                                />
                            </div>
                        </div>
                    )}
                    {invalidError && !captchaV2Error && invalidText != 'Invalid reCAPTCHA!' && (
                        <div className='terminateTile'>
                            <TerminatedTile terminatedCopy={invalidText} />
                        </div>
                    )}
                    {props.flag === 'passwordChanged' && passChangedErr && (
                        <div className='terminateTile'>
                            <TerminatedTile terminatedCopy='Your password has been updated recently, enter your new password' />
                        </div>
                    )}
                </div>
                {!isLoading ? (
                    <MyEirLoginFooter
                        ariaLabel1='Submit login details'
                        button1Text='Submit'
                        button1Enabled={
                            captchaV2 != ''
                                ? !captchaV2Error &&
                                  enableSubmit &&
                                  enableLogin &&
                                  !waitingApiResponse &&
                                  !invalidError
                                : !captchaV2Error &&
                                  enableSubmit &&
                                  enableLogin &&
                                  !waitingApiResponse &&
                                  !invalidError
                        }
                        handleButton1Click={handleSubmitUsername}
                        button2Text='Register'
                        ariaLabel2='Register a new account'
                        handleButton2Click={handleRegister}
                    />
                ) : (
                    <>
                        <EirButton
                            variants='primaryButtonMedium'
                            style={{ padding: '0.5rem 2.5rem' }}
                            // className={classes.paymentContent}
                        >
                            <CircularProgress
                                disableShrink
                                style={{
                                    color: 'white',
                                    width: '17px',
                                    height: '17px',
                                    marginRight: '5px',
                                }}
                            />
                            Submitting...
                        </EirButton>
                        <div className='secondary-cta footer-cta' style={{ marginTop: '18px' }}>
                            <span
                                style={{
                                    cursor: 'text',
                                    color: 'lightgray',
                                    fontSize: '1rem',
                                    fontFamily: 'eirsans-bold',
                                }}
                            >
                                Register{' '}
                            </span>
                        </div>
                    </>
                )}
                <MyEirEmailConfirmationModal
                    // handleNext1={handleNextFlow}
                    handleNext1=''
                    registeredEmail={userName}
                    toggle={toggle2}
                    isOpen={isOpen2}
                    heading={'Reset Password'}
                    subHeading={'We’ve just sent an email to'}
                    text={''}
                    flag='security'
                />
                {openError ? <MyEirErrorHandle open={openError} setOpen={toggleError} /> : ''}
                {showUpdatePopup ? (
                    <LatestAppInfoPopup open={showUpdatePopup} setOpen={togglePopup} />
                ) : (
                    ''
                )}
                {optPopup && (
                    <OptInOptOutPopup
                        open={optPopup}
                        setOpen={setOptPopup}
                        deviceId={userCredential?.deviceId}
                        username={props.username}
                        prepay={isPrepay}
                        flag={userCredential?.deviceId.includes('iOS') ? 'iOS' : 'Android'}
                        subText1={
                            userCredential?.deviceId.includes('iOS')
                                ? 'Use Face ID to login for faster and easier access to your account.'
                                : 'Use face or finger print to login for faster and easier access to your account.'
                        }
                        subText2='If you have multiple accounts, you can set up biometrics for your preferred account.'
                        subText3='Would you like to set it up now?'
                        ctaText={
                            userCredential?.deviceId.includes('iOS')
                                ? 'Turn on Face ID'
                                : 'Enable face or fingerprint'
                        }
                    />
                )}
            </form>
        </div>
    );
};

export default MyEirLoginOperation;
